import { Box, styled } from "@mui/material";
import { IStyledChatBottomProps } from "./types";

const StyledBottom = styled(Box)<IStyledChatBottomProps>(({ theme }) => ({
  position: "sticky",
  padding: "10px",
  backgroundColor: theme.palette.background.paper,
  bottom: "0px",
  width: "100%",
  boxSizing: "border-box",
}));

export { StyledBottom };
